import React from 'react'
import { Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ReactComponent as LanguageFlagNL } from './../../media/language flags/language_nl.svg'
import { ReactComponent as LanguageFlagENUS } from './../../media/language flags/language_en-us.svg'
import { useLanguage } from './../../Utils/Hooks/useLanguage'

export default function LanguageSelector()
{
    const [language, setNewLanguage] = useLanguage();
    
    const menu = (
        <Menu onClick={HandleMenuClick}>
            <Menu.Item key="NL">
                <LanguageFlagNL className='svg-languageflag' />
            </Menu.Item>
            <Menu.Item key="EN">
                <LanguageFlagENUS className='svg-languageflag' />
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
            <Button>
                {getLanguageDescription()}<DownOutlined />
            </Button>
        </Dropdown>
    )

    function getLanguageDescription()
    {
        if(language !== undefined)
        {
            switch(language.name)
            {
                case "NL":
                    return <LanguageFlagNL className='svg-languageflag' />
                case "EN":
                    return <LanguageFlagENUS className='svg-languageflag' />
                default:
                    return language.description
            }
        }
    }

    function HandleMenuClick(e) {
        setNewLanguage(e.key);
    }
}



